"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BondDayOfWeekEnum = exports.FrequencyEnum = exports.SortOrder = exports.RepetitionUnit = exports.TimeUnit = exports.LanguageRegionCodes = exports.DateTimeFormats = void 0;
/**
 * Represents the date time formats.
 */
var DateTimeFormats;
(function (DateTimeFormats) {
    DateTimeFormats["DATE_TIME_FULL"] = "MMMM D, YYYY h:mm A";
    DateTimeFormats["DATE_TIME_FULL_WITH_WEEKDAY"] = "dddd, MMMM D, YYYY h:mm A";
    DateTimeFormats["DATE_SLASHED_SHORT"] = "M/D/YYYY";
    DateTimeFormats["DATE_TIME_SHORT"] = "MMM D, YYYY h:mm A";
    DateTimeFormats["DATE_TIME_SHORT_WITH_DAY"] = "ddd, MMM D, YYYY h:mm A";
    DateTimeFormats["YYYY_MM_DD_T_HH_MM_SS"] = "YYYY-MM-DDTHH:mm:ss";
    DateTimeFormats["YYYY_MM_DD"] = "YYYY-MM-DD";
    DateTimeFormats["SLASHED_DATE"] = "YYYY/MM/DD";
    DateTimeFormats["DATE_FORMAT_WITH_SINGLE_DIGIT_DAY"] = "MMM D, YYYY";
    DateTimeFormats["DAY_FORMAT"] = "MMM DD, YYYY";
    DateTimeFormats["DATE_FORMAT_WITH_MONTH_NAME"] = "MMMM D, YYYY";
    DateTimeFormats["DAY_FORMAT_SLASHED"] = "MM/DD/YYYY";
    // TODO: remove this format after using DAY_OF_WEEK_FORMAT as replacement in BO
    DateTimeFormats["DAY"] = "ddd";
    DateTimeFormats["MONTH"] = "MMM";
    DateTimeFormats["DAY_OF_WEEK_FORMAT"] = "ddd";
    DateTimeFormats["DAY_FORMAT_WITH_DAY_OF_WEEK"] = "ddd, MMM DD, YYYY";
    DateTimeFormats["MMMM_YYYY"] = "MMMM YYYY";
    DateTimeFormats["MMM_DD"] = "MMM DD";
    DateTimeFormats["MMM_D"] = "MMM D";
    DateTimeFormats["MONTH_DAY_COMMA_YEAR"] = "MMM DD, YYYY";
    DateTimeFormats["DDD_MMM_DD"] = "ddd, MMM DD";
    DateTimeFormats["DD_MM_YYY_SLASHED"] = "DD/MM/YYYY";
    DateTimeFormats["DAY_OF_WEEK_AND_1H12_AMPM"] = "ddd hh:mm a";
    DateTimeFormats["H24_WITH_SECONDS"] = "HH:mm:ss";
    DateTimeFormats["H24_WITH_MINUTES"] = "HH:mm";
    DateTimeFormats["H12_WITH_MINUTES"] = "hh:mm";
    DateTimeFormats["H12_AMPM"] = "hh:mm a";
    DateTimeFormats["H12_AMPM_UPPERCASE"] = "hh:mm A";
    DateTimeFormats["H12_AMPM_UPPERCASE_WITH_SECONDS"] = "h:mm:ss A";
    DateTimeFormats["TIME_12_HOUR"] = "h:mmA";
})(DateTimeFormats = exports.DateTimeFormats || (exports.DateTimeFormats = {}));
/**
 * Represents the date range.
 */
var LanguageRegionCodes;
(function (LanguageRegionCodes) {
    LanguageRegionCodes["EN_US"] = "en-US";
    LanguageRegionCodes["EN_CA"] = "en-CA";
    LanguageRegionCodes["EN_GB"] = "en-GB";
    LanguageRegionCodes["FR_CA"] = "fr-CA";
    LanguageRegionCodes["FR_FR"] = "fr-FR";
})(LanguageRegionCodes = exports.LanguageRegionCodes || (exports.LanguageRegionCodes = {}));
/**
 * Represents the time unit.
 */
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["DAY"] = "day";
    TimeUnit["WEEK"] = "week";
    TimeUnit["MONTH"] = "month";
    TimeUnit["YEAR"] = "year";
    TimeUnit["MINUTE"] = "minute";
    TimeUnit["HOUR"] = "hour";
    TimeUnit["SECOND"] = "second";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
/**
 * Represents the repetition unit.
 */
var RepetitionUnit;
(function (RepetitionUnit) {
    RepetitionUnit["DAY"] = "day";
    RepetitionUnit["WEEK"] = "week";
    RepetitionUnit["MONTH"] = "month";
    RepetitionUnit["QUARTER"] = "quarter";
    RepetitionUnit["YEAR"] = "year";
})(RepetitionUnit = exports.RepetitionUnit || (exports.RepetitionUnit = {}));
/**
 * Represents the sort order.
 */
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var FrequencyEnum;
(function (FrequencyEnum) {
    FrequencyEnum["NONE"] = "none";
    FrequencyEnum["WEEKLY"] = "weekly";
    FrequencyEnum["DAILY"] = "daily";
    FrequencyEnum["MONTHLY"] = "monthly";
    FrequencyEnum["YEARLY"] = "yearly";
})(FrequencyEnum = exports.FrequencyEnum || (exports.FrequencyEnum = {}));
var BondDayOfWeekEnum;
(function (BondDayOfWeekEnum) {
    BondDayOfWeekEnum[BondDayOfWeekEnum["MONDAY"] = 2] = "MONDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["TUESDAY"] = 3] = "TUESDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["WEDNESDAY"] = 4] = "WEDNESDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["THURSDAY"] = 5] = "THURSDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["FRIDAY"] = 6] = "FRIDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["SATURDAY"] = 7] = "SATURDAY";
    BondDayOfWeekEnum[BondDayOfWeekEnum["SUNDAY"] = 8] = "SUNDAY";
})(BondDayOfWeekEnum = exports.BondDayOfWeekEnum || (exports.BondDayOfWeekEnum = {}));
//# sourceMappingURL=enums.js.map